import { Controller } from "@hotwired/stimulus"

export  class NavbarController extends Controller {
  static targets = ["collapse"]


  connect() {
    $(this.collapseTarget)
      .on("show.bs.collapse", () => this.element.classList.add("expanded"))
      .on("hidden.bs.collapse", () => this.element.classList.remove("expanded"))
  }

  disconnect() {
    $(this.collapseTarget).off("show.bs.collapse hidden.bs.collapse")
  }

  closeCollapse() {
    const $collapse = $(this.collapseTarget)
    if ($collapse.hasClass("show")) {
      $collapse.collapse("hide")
    }
  }
}
